module.exports = __webpack_public_path__ + "static/img/name1.7975beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name1.png
// module id = BQBz
// module chunks = 1